const ITEMS = ["Cold Storage", "Freezer Room", "Chiller Room", "Blast Freezer", "Refrigeration System", "Custom Cooling Solution"];

export function TrustMarquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="trust-bar" className="relative border-y border-glacier/15 bg-navy-900 py-6 overflow-hidden marquee-mask">
      <p className="sr-only">Solusi Pendinginan untuk Berbagai Kebutuhan Bisnis</p>
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display text-2xl sm:text-3xl font-semibold uppercase tracking-wide text-frost/80 px-8">{item}</span>
                <span className="w-2 h-2 rotate-45 bg-ice/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
